/**
 * Temporary allowlist: Internal SE users who get PAE Partner Portal access for testing.
 * Remove emails here when access is no longer needed.
 */
export const INTERNAL_SE_PARTNER_PORTAL_PAE_EMAILS = [
  'michael.viana@helixops.ai',
];
